import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import { useParams } from 'react-router-dom';
import FormCrud from '../../components/FormCrud';

const ModuleForm = () => {
    const [operationsOptions, setOperationsOptions] = useState(null);
    const [operations, setOperations] = useState(null);
    const [reportOptions, setReportOptions] = useState(null);
    const [selectedReportYearID, setSelectedReportYearID] = useState();
    const [companysOptions, setCompanysOptions] = useState(null);
    const { id } = useParams();

    const activeOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];

    const selectReportYear = (e, event) => {
        const value = event?.target?.value ?? e?.getFieldRef?.("reportYearID")?.current?.value;
        if (value !== undefined && value !== null) setSelectedReportYearID(value);
    }

    const fields = [
        {
            label: "Report Year",
            name: "reportYearID",
            type: "select",
            options: reportOptions,
            onChanged: selectReportYear
        },
        {
            label: "Form",
            name: "operationID",
            type: "select",
            options: operationsOptions
        },
        {
            label: "Module Description",
            name: "description",
            type: "input",
            disabled: false
        },
        {
            label: "Guidance",
            name: "guidance",
            type: "textarea",
            required: false
        },
        {
            label: "Order",
            name: "order",
            type: "number"
        },
        {
            label: "Companies to exclude",
            name: "moduleCompany",
            type: "select",
            required: false,
            options: companysOptions,
            multiple: true
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: activeOptions
        },
        {
            label: "Is FSM Module?",
            name: "isFSMModule",
            type: "select",
            options: activeOptions
        },
        {
            label: "Show Add Zeros button?",
            name: "isHandleAddZeros",
            type: "select",
            options: activeOptions
        },
    ];


    const loadData = async () => {
        try {
            const result = await Api.get('Operation/getAll');
            if (result && result.data) {
                const options = result.data.response.map(item => ({ 
                    value: item.operationID, 
                    text: item.description, 
                    reportYearID: item.reportYearID 
                }));
                setOperations(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadCompanies = async (cultureID) => {
        try {
            const result = await Api.get(`Company/getAllByCulture?cultureID=${cultureID}`);
            if (result && result.data) {
                const options = result.data.response.map(item => ({ 
                    value: item.companyID, 
                    text: item.name 
                }));
                setCompanysOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadReportYear = async () => {
        const userLogged = JSON.parse(localStorage.getItem('@Thrive:user'));
        try {
            const result = await Api.get(`Culture/getAllReportYearsByCulture?cultureID=${userLogged.selectedCultureID}`);
            if (result && result.data) {
                const options = result.data.response?.reportYears?.map(item => ({ 
                    value: item.reportYearID, 
                    text: `${item.year}` 
                }));

                if (!id && options.length > 0) setSelectedReportYearID(options[0].value);
                setReportOptions(options);
                
                await loadCompanies(userLogged.selectedCultureID);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    useEffect(() => {
        if (operations != null && selectedReportYearID) {
            const filtered = operations.filter(x => x.reportYearID == selectedReportYearID);
            setOperationsOptions(filtered);
        }
    }, [selectedReportYearID, operations]);

    useEffect(() => {
        loadData();
        loadReportYear();
    }, []);

    const isReady = operations !== null && reportOptions !== null && companysOptions !== null;

    return (
        isReady ? (
            <FormCrud 
                formName={"module"} 
                title={"Module"} 
                fields={fields} 
                setSelectedReportYearID={setSelectedReportYearID}
            />
        ) : <></>
    );
}

export default ModuleForm;